export const CUR_SYMBOLS = { USD: '$', EUR: '€', GBP: '£', INR: '₹' };

export const getCurSym = (analysis) =>
  CUR_SYMBOLS[analysis?.data_governance?.currency || analysis?.currency || 'USD'] || '$';

export const hasPeerValue = (v) =>
  v != null && v !== '' && v !== '-' && String(v).trim().toLowerCase() !== 'n/a';

export const hasMetric = value => typeof value === 'number' && Number.isFinite(value);
export const metricText = (value, unit = '') => hasMetric(value) ? `${value}${unit}` : 'Not available';
export const impactText = (value, symbol = '$', digits = 1) => hasMetric(value) ? `${symbol}${(value / 1000000).toFixed(digits)}M` : 'Not available';
export const metricComparison = (kpi, lowerIsBetter) => {
  if (!hasMetric(kpi.yourValue) || !hasMetric(kpi.industryAvg)) return null;
  return Math.sign((kpi.yourValue - kpi.industryAvg) * (lowerIsBetter ? -1 : 1));
};
export function scorecardStats(kpis, isLowerBetter) {
  const comparisons = kpis.map(k => metricComparison(k, isLowerBetter(k.name)));
  const comparableCount = comparisons.filter(c => c !== null).length;
  const impacts = kpis.map(k => k.impactPer1Percent).filter(hasMetric);
  const gaps = kpis.filter(k => hasMetric(k.yourValue) && hasMetric(k.topPerformer) && k.topPerformer !== 0);
  return {
    comparableCount,
    kpisAboveAvg: comparableCount ? comparisons.filter(c => c === 1).length : null,
    kpisBelowAvg: comparableCount ? comparisons.filter(c => c === -1).length : null,
    totalPotentialImpact: impacts.length ? impacts.reduce((a, b) => a + b, 0) : null,
    impactCount: impacts.length,
    avgPerformanceGap: gaps.length ? (gaps.reduce((sum, k) => sum + Math.abs((k.topPerformer - k.yourValue) / k.topPerformer * 100), 0) / gaps.length).toFixed(1) : null,
  };
}
